export const PartnerServiceOptions = {
  LEGAL_PARTNER: {
    formId: '502',
    code: 'Partner Legal Extend',
  },
  PARTNERS_EXT: {
    formId: '406',
    code: 'PartnersExt',
  },
  PARTNER_ADDITIONAL: {
    formId: '458',
    code: 'PartnerAdditionalInfo',
  },
  PARTNER_FLAG_REQUEST: {
    formId: '519',
    code: 'PartnerFlagsRequests',
  },
}

export enum PartnerDataType {
  BASIC = 'basic',
  LEGAL = 'legal',
}

export const EMPTY_FETCH_MY_PARTNERS_RESULT = {
  partners: [],
  total: 0,
}
